var map = {
	"./avatar_1.jpg": 2107,
	"./avatar_10.jpg": 3816,
	"./avatar_11.jpg": 8933,
	"./avatar_2.jpg": 8130,
	"./avatar_3.jpg": 5825,
	"./avatar_4.jpg": 5325,
	"./avatar_5.jpg": 3805,
	"./avatar_6.jpg": 286,
	"./avatar_7.jpg": 2339,
	"./avatar_8.jpg": 9539,
	"./avatar_9.jpg": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;